import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import xyz.malefic.hell.components.layouts.MiiCustomizeLayout as _xyz_malefic_hell_components_layouts_MiiCustomizeLayout
import xyz.malefic.hell.components.layouts.PageLayout as _xyz_malefic_hell_components_layouts_PageLayout
import xyz.malefic.hell.pages.AboutPage as _xyz_malefic_hell_pages_AboutPage
import xyz.malefic.hell.pages.ChannelPage as _xyz_malefic_hell_pages_ChannelPage
import xyz.malefic.hell.pages.CustomizeMii as _xyz_malefic_hell_pages_CustomizeMii
import xyz.malefic.hell.pages.HomePage as _xyz_malefic_hell_pages_HomePage
import xyz.malefic.hell.pages.kitchen.Kitchen1 as _xyz_malefic_hell_pages_kitchen_Kitchen1

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Hell's Kitchen"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "xyz.malefic.hell.components.layouts.MiiCustomizeLayout",
        ) { pageCtx, pageMethod -> 
            _xyz_malefic_hell_components_layouts_MiiCustomizeLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "xyz.malefic.hell.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _xyz_malefic_hell_components_layouts_PageLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "xyz.malefic.hell.components.layouts.PageLayout",
        ) { pageCtx -> 
            _xyz_malefic_hell_pages_HomePage(pageCtx)
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _xyz_malefic_hell_pages_AboutPage()
        }
        ctx.router.register(
            "/channel/{level}",
            layoutId = "xyz.malefic.hell.components.layouts.PageLayout",
        ) { pageCtx -> 
            _xyz_malefic_hell_pages_ChannelPage(pageCtx)
        }
        ctx.router.register(
            "/character-customize",
            layoutId = "xyz.malefic.hell.components.layouts.MiiCustomizeLayout",
        ) { pageCtx -> 
            _xyz_malefic_hell_pages_CustomizeMii(pageCtx)
        }
        ctx.router.register(
            "/kitchen/1",
        ) { pageCtx -> 
            _xyz_malefic_hell_pages_kitchen_Kitchen1(pageCtx)
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("empty-css", xyz.malefic.hell.components.emptyCss)
        ctx.theme.registerStyle("kitchen-styles_container", xyz.malefic.hell.styles.KitchenStyles.container)
        ctx.theme.registerStyle("kitchen-styles_content", xyz.malefic.hell.styles.KitchenStyles.content)
        ctx.theme.registerStyle("kitchen-styles_leave", xyz.malefic.hell.styles.KitchenStyles.leave)
        ctx.theme.registerStyle("kitchen-styles_kitchen-container", xyz.malefic.hell.styles.KitchenStyles.kitchenContainer)
        ctx.theme.registerStyle("kitchen-styles_floor", xyz.malefic.hell.styles.KitchenStyles.floor)
        ctx.theme.registerStyle("kitchen-styles_counter", xyz.malefic.hell.styles.KitchenStyles.counter)
        ctx.theme.registerStyle("kitchen-styles_cutting-board", xyz.malefic.hell.styles.KitchenStyles.cuttingBoard)
        ctx.theme.registerStyle("kitchen-styles_stove", xyz.malefic.hell.styles.KitchenStyles.stove)
        ctx.theme.registerStyle("kitchen-styles_burner", xyz.malefic.hell.styles.KitchenStyles.burner)
        ctx.theme.registerStyle("kitchen-styles_burner-tall", xyz.malefic.hell.styles.KitchenStyles.burnerTall)
        ctx.theme.registerStyle("kitchen-styles_character", xyz.malefic.hell.styles.KitchenStyles.character)
        ctx.theme.registerStyle("kitchen-styles_character-face", xyz.malefic.hell.styles.KitchenStyles.characterFace)
        ctx.theme.registerStyle("kitchen-styles_footer", xyz.malefic.hell.styles.KitchenStyles.footer)
        ctx.theme.registerStyle("kitchen-styles_instructions", xyz.malefic.hell.styles.KitchenStyles.instructions)
        ctx.theme.registerStyle("kitchen-styles_clock", xyz.malefic.hell.styles.KitchenStyles.clock)
        ctx.theme.registerStyle("kitchen-styles_date", xyz.malefic.hell.styles.KitchenStyles.date)
        ctx.theme.registerStyle("wii-channel-styles_container", xyz.malefic.hell.styles.WiiChannelStyles.container)
        ctx.theme.registerStyle("wii-channel-styles_background", xyz.malefic.hell.styles.WiiChannelStyles.background)
        ctx.theme.registerStyle("wii-channel-styles_content", xyz.malefic.hell.styles.WiiChannelStyles.content)
        ctx.theme.registerStyle("wii-channel-styles_header-section", xyz.malefic.hell.styles.WiiChannelStyles.headerSection)
        ctx.theme.registerStyle("wii-channel-styles_icon-container", xyz.malefic.hell.styles.WiiChannelStyles.iconContainer)
        ctx.theme.registerStyle("wii-channel-styles_shopping-bag", xyz.malefic.hell.styles.WiiChannelStyles.shoppingBag)
        ctx.theme.registerStyle("wii-channel-styles_shopping-bag-secondary", xyz.malefic.hell.styles.WiiChannelStyles.shoppingBagSecondary)
        ctx.theme.registerStyle("wii-channel-styles_title", xyz.malefic.hell.styles.WiiChannelStyles.title)
        ctx.theme.registerStyle("wii-channel-styles_left-arrow", xyz.malefic.hell.styles.WiiChannelStyles.leftArrow)
        ctx.theme.registerStyle("wii-channel-styles_right-arrow", xyz.malefic.hell.styles.WiiChannelStyles.rightArrow)
        ctx.theme.registerStyle("wii-channel-styles_bottom-bar", xyz.malefic.hell.styles.WiiChannelStyles.bottomBar)
        ctx.theme.registerStyle("wii-channel-styles_nav-button", xyz.malefic.hell.styles.WiiChannelStyles.navButton)
        ctx.theme.registerStyle("wii-home-styles_container", xyz.malefic.hell.styles.WiiHomeStyles.container)
        ctx.theme.registerStyle("wii-home-styles_content", xyz.malefic.hell.styles.WiiHomeStyles.content)
        ctx.theme.registerStyle("wii-home-styles_sidebar-left", xyz.malefic.hell.styles.WiiHomeStyles.sidebarLeft)
        ctx.theme.registerStyle("wii-home-styles_sidebar-right", xyz.malefic.hell.styles.WiiHomeStyles.sidebarRight)
        ctx.theme.registerStyle("wii-home-styles_channel-grid", xyz.malefic.hell.styles.WiiHomeStyles.channelGrid)
        ctx.theme.registerStyle("wii-home-styles_footer", xyz.malefic.hell.styles.WiiHomeStyles.footer)
        ctx.theme.registerStyle("wii-home-styles_channel-button", xyz.malefic.hell.styles.WiiHomeStyles.channelButton)
        ctx.theme.registerStyle("wii-home-styles_wii-button", xyz.malefic.hell.styles.WiiHomeStyles.wiiButton)
        ctx.theme.registerStyle("wii-home-styles_clock", xyz.malefic.hell.styles.WiiHomeStyles.clock)
        ctx.theme.registerStyle("wii-home-styles_date", xyz.malefic.hell.styles.WiiHomeStyles.date)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        xyz.malefic.hell.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
